import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WdxFileIconComponent } from '@wdx/shared/components/wdx-file-icon';
import { FileIndex } from '@wdx/shared/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface FileIconRendererValue {
    label?: string;
    fileIndex?: FileIndex;
    clickCallback?: (fileIndex?: FileIndex) => void;
}

@Component({
    selector: 'wdx-ag-grid-file-icon-cell-renderer',

    imports: [CommonModule, RouterModule, WdxFileIconComponent],
    templateUrl: './file-icon-renderer.component.html',
})
export class FileIconRendererComponent implements ICellRendererAngularComp {
    public label?: string;
    public fileIndex?: FileIndex;
    public clickCallback?: (fileIndex?: FileIndex) => void;

    public agInit(
        params: ICellRendererParams<any, FileIconRendererValue>,
    ): void {
        if (params?.value) {
            this.label = params.value.label;
            this.fileIndex = params.value.fileIndex;
            this.clickCallback = params.value.clickCallback;
        }
    }

    public refresh(
        params: ICellRendererParams<any, FileIconRendererValue>,
    ): boolean {
        this.agInit(params);
        return true;
    }

    public handleClick(): void {
        this.clickCallback?.(this.fileIndex);
    }
}
